// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#page1_bscbo1{position:relative;width:33%;height:100%;background-color:rgba(6,30,93,.5);box-sizing:border-box;margin-left:10px}#page1_bscbo1 .box{height:100%;width:100%}", ""]);
// Exports
module.exports = exports;
